import type {
  WebhookDeliveryStatus,
  WebhookEndpointStatus,
  WebhookEnvironment,
} from '@compass/client/types/webhook';
import { WebhookEnvironment as Env } from '@compass/client/types/webhook';
import { ShieldCheck } from 'lucide-react';
import React from 'react';

import { Badge } from '@/components/ui/badge';
import { SimpleTooltipV2 } from '@/components/ui/tooltip';

import {
  deliveryStatusLabel,
  deliveryStatusVariant,
  endpointStatusLabel,
  endpointStatusVariant,
  environmentLabel,
  MANAGED_ENDPOINT_HINT,
  MANAGED_ENDPOINT_LABEL,
} from '../utils';

export function EndpointStatusBadge({ status }: { status: WebhookEndpointStatus | undefined }) {
  return <Badge variant={endpointStatusVariant(status)}>{endpointStatusLabel(status)}</Badge>;
}

export function DeliveryStatusBadge({ status }: { status: WebhookDeliveryStatus | undefined }) {
  return <Badge variant={deliveryStatusVariant(status)}>{deliveryStatusLabel(status)}</Badge>;
}

export function EnvironmentBadge({ environment }: { environment: WebhookEnvironment | undefined }) {
  return (
    <Badge variant={environment === Env.WEBHOOK_ENVIRONMENT_SANDBOX ? 'secondary' : 'outline'}>
      {environmentLabel(environment)}
    </Badge>
  );
}

/** Marks an endpoint 100ms support set up; customers can view it but not change it. */
export function ManagedEndpointBadge() {
  return (
    <SimpleTooltipV2 content={MANAGED_ENDPOINT_HINT}>
      <Badge variant="secondary" className="gap-1 font-normal whitespace-nowrap">
        <ShieldCheck className="h-3 w-3" aria-hidden="true" />
        {MANAGED_ENDPOINT_LABEL}
      </Badge>
    </SimpleTooltipV2>
  );
}
